<template>
	<div class="container">
		<div class="nav_top">
			<div class="nav">
				<div :class="nav_index==index?'nav_default_cli':'nav_default'" v-for="(item,index) in nav" @click="nav_cli(item,index,item.inde)">
					<div>{{item.name}}</div>
					<div class="border_bottom" v-show="nav_index==index"></div>
				</div>
			</div>
		</div>
		<div class="fill_topp" v-if="orderlistShow">暂无订单</div>
		<div class="ticket_fill" v-if="!orderlistShow">
			<div class="fill_top" v-for="item in orderlist" v-if="inde==10">
				<div class="fill_top_head" @click="fill_list(item.orderid,item.holder)">
					<div class="fill_top_head_photo">
						<img :src="item.ticketactivity.imageurl" />
					</div>
					<div class="fill_top_head_text">
						<p>{{item.ticketactivity.title}}</p>
						<p>时间 <span>{{item.appointment_time}}</span>
						<span v-if="item.paragraphid=='7a20e24c64724601af7bd7a656fe56db'">上午</span>
						<span v-if="item.paragraphid=='9a81ca2d40374642b29321438d610432'">下午</span>
						<span v-if="item.paragraphid=='8fa02b6e5a45459e8356f66c9869164e'">上午</span>
						<span v-if="item.paragraphid=='52ce14988c354b949b39306a1aac8850'">下午</span>
						<!-- <span>{{item.paragraphid}}</span> -->
						</p>
						<p>{{item.ticketactivity.summary}}</p>
					</div>
					<div v-if="item.status==0" class="fill_right_0">待完成</div>
					<div v-if="item.status==1" class="fill_right_1">待出行</div>
					<div v-if="item.status==2" class="fill_right_3">已完成</div>
					<div v-if="item.status==3" class="fill_right_3">已取消</div>
					<div v-if="item.status==4" class="fill_right_4">已过期</div>
					<div v-if="item.status==5" class="fill_right_5">审核中</div>
					<div v-if="item.status==6" class="fill_right_6">未通过</div>
				</div>
				<div v-if="item.status==0" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-show="item.holder==1" @click="CancelReservation(item.orderid)">取消</div>
				</div>
				<div v-if="item.status==1" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==1" @click="explain(item.orderid)">预约讲解</div>
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==2" @click="explainDetails(item.taskid)">查看讲解</div>
					<div class="sheets_rem" v-show="item.holder==1" @click="CancelReservation(item.orderid)">取消</div>
				</div>
				<div v-if="item.status==2&&item.iscoment==0" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<!--<div class="sheets_rem">删除</div>-->
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==2" @click="explainDetails(item.taskid)">查看讲解</div>
					<div class="sheets_rem" @click="ReadingFile(item.orderid)">写观后感</div>
				</div>
				<div v-if="item.status==2&&item.iscoment==1" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==2" @click="explainDetails(item.taskid)">查看讲解</div>
					<!--<div class="sheets_rem">删除</div>-->
				</div>
				<div v-if="item.status==3" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
				</div>
				<div v-if="item.status==4" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<!--<div class="sheets_rem">删除</div>-->
				</div>
				<div v-if="item.status==5" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-show="item.holder==1" @click="CancelReservation(item.orderid)">取消</div>
				</div>
				<div v-if="item.status==6" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<!--<div class="sheets_rem">删除</div>-->
				</div>
			</div>
			<div class="fill_top" v-for="item in orderlist" v-if="inde==item.status">
				<div class="fill_top_head" @click="fill_list(item.orderid,item.holder)">
					<div class="fill_top_head_photo">
						<img :src="item.ticketactivity.imageurl" />
					</div>
					<div class="fill_top_head_text">
						<p>{{item.ticketactivity.title}}</p>
						<p >时间 <span>{{item.appointment_time}}</span>
						<span v-if="item.paragraphid=='7a20e24c64724601af7bd7a656fe56db'">上午</span>
						<span v-if="item.paragraphid=='9a81ca2d40374642b29321438d610432'">下午</span>
						<span v-if="item.paragraphid=='8fa02b6e5a45459e8356f66c9869164e'">上午</span>
						<span v-if="item.paragraphid=='52ce14988c354b949b39306a1aac8850'">下午</span>
						<!-- <span>{{item.paragraphname}}</span> -->
						</p>
						<p>{{item.ticketactivity.summary}}</p>
					</div>
					<div v-if="item.status==0" class="fill_right_0">待完成</div>
					<div v-if="item.status==1" class="fill_right_1">待出行</div>
					<div v-if="item.status==2" class="fill_right_3">已完成</div>
					<div v-if="item.status==3" class="fill_right_3">已取消</div>
					<div v-if="item.status==4" class="fill_right_4">已过期</div>
					<div v-if="item.status==5" class="fill_right_5">审核中</div>
					<div v-if="item.status==6" class="fill_right_6">未通过</div>
				</div>
				<div v-if="item.status==0" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-show="item.holder==1" @click="CancelReservation(item.orderid)">取消</div>
				</div>
				<div v-if="item.status==1" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==1" @click="explain(item.orderid)">预约讲解</div>
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==2" @click="explainDetails(item.taskid)">查看讲解</div>
					<div class="sheets_rem" v-show="item.holder==1" @click="CancelReservation(item.orderid)">取消</div>
				</div>
				<div v-if="item.status==2&&item.iscoment==0" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==2" @click="explainDetails(item.taskid)">查看讲解</div>
					<!--<div class="sheets_rem">删除</div>-->
					<div class="sheets_rem" @click="ReadingFile(item.orderid)">写观后感</div>
				</div>
				<div v-if="item.status==2&&item.iscoment==1" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<!--<div class="sheets_rem">删除</div>-->
					<div class="sheets_rem" v-if="test" v-show="item.holder==1&&item.isexplan==2" @click="explainDetails(item.taskid)">查看讲解</div>
				</div>
				<div v-if="item.status==3" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
				</div>
				<div v-if="item.status==4" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<!--<div class="sheets_rem">删除</div>-->
				</div>
				<div v-if="item.status==5" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<div class="sheets_rem" v-show="item.holder==1" @click="CancelReservation(item.orderid)">取消</div>
				</div>
				<div v-if="item.status==6" class="fill_top_bottom">
					<div class="fill_sheets">预定时间：<span>{{item.createtime}}</span></div>
					<!--<div class="sheets_rem">删除</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'PersonalCenter',
		data() {
			return {
				nav: [],
				baseUrl: "",
				orderlist: "",
				inde: '10',
				teamtype: '',
				loginType: '',
				nav_index: 0,
				orderlistShow: false,
				test: false
			}
		},
		methods: {
			explainDetails(explain_taskid) {
				var that = this;
				sessionStorage.setItem("explain_taskid", explain_taskid);
				that.$router.push({
					name: "ExplainDetails"
				})
			},
			explain(explain_orderid) {
				var that = this;
				sessionStorage.setItem("explain_orderid", explain_orderid);
				that.$router.push({
					name: "Explain"
				})
			},
			nav_cli(item, index, inde) {
				var that = this;
				that.inde = inde;
				that.nav_index = index;
			},
			fill_list(id, holder) {
				var that = this;
				sessionStorage.removeItem('holder')
				sessionStorage.removeItem('tcid')
				sessionStorage.setItem("orderid", id);
				sessionStorage.setItem("holder", holder);
				that.$router.push({
					name: "AppointmentDetails"
				})

			},
			ReadingFile(id) {
				var that = this;
				sessionStorage.setItem("read_orderid", id);
				that.$router.push({
					name: "ReadingFile"
				})
			},
			CancelReservation(e) {
				var that = this;
				sessionStorage.setItem("cancel_orderid", e);
				that.$router.push({
					name: "CancelReservation"
				})
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.nav = [{
					"name": "全部订单",
					"inde": 10
				}, {
					"name": "待出行",
					"inde": 1
				}, {
					"name": "已完成",
					"inde": 2
				}, {
					"name": "已取消",
					"inde": 3
				}, {
					"name": "已过期",
					"inde": 4
				}, {
					"name": "审核中",
					"inde": 5
				}, {
					"name": "未通过",
					"inde": 6
				}, {
					"name": "观后感",
					"inde": 2
				}];
				that.test = true;
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.nav = [{
					"name": "全部订单",
					"inde": 10
				}, {
					"name": "待出行",
					"inde": 1
				}, {
					"name": "已完成",
					"inde": 2
				}, {
					"name": "已取消",
					"inde": 3
				}, {
					"name": "已过期",
					"inde": 4
				}, {
					"name": "审核中",
					"inde": 5
				}, {
					"name": "未通过",
					"inde": 6
				}, {
					"name": "观后感",
					"inde": 2
				}];
				that.test = true;
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
				that.nav = [{
					"name": "全部订单",
					"inde": 10
				}, {
					"name": "待出行",
					"inde": 1
				}, {
					"name": "已完成",
					"inde": 2
				}, {
					"name": "已取消",
					"inde": 3
				}, {
					"name": "已过期",
					"inde": 4
				}, {
					"name": "未通过",
					"inde": 6
				}, {
					"name": "观后感",
					"inde": 2
				}];
				that.test = false;
			}
			that.baseUrl = baseUrl;
			that.loginType = sessionStorage.getItem('loginType')
			that.teamtype = sessionStorage.getItem('teamtype')
			wclient.view.showLoading();
			if(that.loginType == 'teamLogin') {
				if(that.teamtype == '5') {
					$.ajax({
						type: "get",
						url: that.baseUrl + '/tickets/tickets/ajax?ugi=userTicket&action=getUserTicketList&moduleid=TICKETS',
						async: true,
						dataType: 'jsonp',
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						success: function(res) {
							wclient.view.hideLoading();
							if(!res.orderlist) {
								that.orderlistShow = true;
							} else {
								that.orderlist = res.orderlist;
							}
						}
					});
				} else {
					$.ajax({
						type: "get",
						url: that.baseUrl + '/tickets/tickets/ajax?ugi=userteamticket&action=getUserTicketList',
						async: true,
						dataType: 'jsonp',
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						success: function(res) {
							wclient.view.hideLoading();
							if(!res.orderlist) {
								that.orderlistShow = true;
							} else {
								that.orderlist = res.orderlist;
							}
						}
					});
				}
			} else {
				$.ajax({
					type: "get",
					url: that.baseUrl + '/tickets/tickets/ajax?ugi=userTicket&action=getUserTicketList&moduleid=TICKETS',
					async: true,
					dataType: 'jsonp',
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					success: function(res) {
						wclient.view.hideLoading();
						if(!res.orderlist) {
							that.orderlistShow = true;
						} else {
							that.orderlist = res.orderlist;
						}
					}
				});
			}
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.nav_top {
		width: 100%;
		overflow: hidden;
		position: fixed;
		top: 0;
		left: 0;
		background: #EEEEEE;
	}
	
	.nav {
		display: -webkit-box;
		justify-content: space-between;
		padding: 0 3%;
		overflow-x: auto;
	}
	
	::-webkit-scrollbar {
		display: none
	}
	
	.nav>div {
		width: 20%;
	}
	
	.nav_default {
		margin: 9px 3px;
		font-size: 14px;
		text-align: center;
		color: rgba(148, 147, 153, 1);
	}
	
	.nav_default_cli {
		margin: 7px 3px;
		font-size: 15px;
		text-align: center;
		color: rgba(207, 18, 14, 1);
	}
	
	.border_bottom {
		width: 50%;
		border-bottom: 2px solid rgba(207, 18, 14, 1);
		margin-left: 25%;
		margin-top: 3px;
	}
	
	.ticket_fill {
		width: 100%;
		margin-top: 50px;
	}
	
	.fill_top {
		width: 86%;
		float: left;
		background: url(../assets/fill_top.png) center center no-repeat;
		background-size: 100% 100%;
		margin: 0 3% 15px;
		padding: 4% 4% 3% 4%;
	}
	
	.fill_topp {
		width: 100%;
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 18px;
	}
	
	.fill_top_head {
		float: left;
		width: 100%;
		display: flex;
		justify-content: flex-start;
	}
	
	.fill_top_head_photo {
		width: 72px;
		height: 72px;
		border-radius: 10px;
		overflow: hidden;
	}
	
	.fill_top_head_text {
		width: 60%;
		margin-left: 5%;
	}
	
	.fill_top_head_text p {
		width: 100%;
		color: #919CA2;
		font-size: 12px;
		text-overflow: ellipsis;
		/* display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 1;
		overflow: hidden; */
	}
	
	.fill_top_head_text span {
		margin-right: 10px;
	}
	
	.fill_top_head_text p:nth-child(1) {
		margin-bottom: 5px;
		color: black;
		font-weight: 600;
		letter-spacing: 1px;
		font-size: 16px;
	}
	
	.fill_right_0 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: deepskyblue;
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_right_1 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: rgba(138, 195, 73, 1);
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_right_2 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: royalblue;
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_right_3 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: rgba(198, 198, 198, 1);
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_right_4 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: cornflowerblue;
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_right_5 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: #F39925;
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_right_6 {
		width: 15%;
		height: 20px;
		line-height: 20px;
		background: #D01511;
		border-radius: 2px;
		font-size: 12px;
		text-align: center;
		color: white;
	}
	
	.fill_top_bottom {
		width: 100%;
		float: left;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.fill_sheets {
		font-size: 12px;
		color: rgba(187, 187, 187, 1);
		line-height: 20px;
		width: 50%;
	}
	
	.sheets_rem {
		border: 1px solid rgba(194, 194, 194, 1);
		padding: 2px 15px;
		font-size: 12px;
		color: rgba(161, 168, 172, 1);
		text-align: center;
		border-radius: 8px;
	}
	
	p {
		margin-bottom: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/ticketReservation.vue